export default __webpack_public_path__ + "static/media/ieltsinternationalacademy.4f933318.png";